import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.648115, 166.952416, 15.8],
  [-11.648055, 166.952598, 15.6],
];

export default stream;
